
@if(isLoading()) {
    <div class="text-center py-20 text-slate-500">
        <i class="fa-solid fa-circle-notch animate-spin text-4xl text-purple-500 mb-4"></i>
        <p>Loading plans...</p>
    </div>
} @else {
    <div class="space-y-12">
        <!-- Clinic Plans -->
        <div>
            <h3 class="text-xl font-bold text-white mb-6 pl-3 border-l-4 border-blue-500 flex items-center gap-2">
                <i class="fa-solid fa-user-doctor text-blue-400"></i> Clinic Plans (คลินิก)
            </h3>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                @for(plan of clinicPlans(); track plan.id) {
                    <div class="bg-slate-900 border border-slate-800 rounded-xl p-6 hover:border-blue-500/50 transition-all group relative">
                        <div class="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button (click)="editPlan(plan)" class="text-blue-400 hover:text-white bg-slate-800 p-2 rounded-lg transition-colors"><i class="fa-solid fa-pen-to-square"></i></button>
                        </div>
                        <h3 class="text-xl font-bold text-white mb-1">{{ plan.name }}</h3>
                        <p class="text-slate-400 text-sm font-mono mb-4">{{ plan.id }}</p>
                        <p class="text-3xl font-black text-emerald-400 mb-6">฿{{ plan.price_monthly | number }} <span class="text-sm font-normal text-slate-500">/{{ plan.interval || 'month' }}</span></p>
                        <div class="space-y-2 text-sm text-slate-300">
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>Case Limit</span><span class="font-bold text-white">{{ plan.limits['medical_cases'] || 'Unlimited' }}</span></div>
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>User Limit</span><span class="font-bold text-white">{{ plan.limits['users'] || 'Unlimited' }}</span></div>
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>Overage Cost</span><span class="font-bold text-white">{{ plan.limits['overage_cost'] || 0 }} THB</span></div>
                        </div>
                    </div>
                }
            </div>
        </div>

        <!-- Dispensary Plans -->
        <div>
            <h3 class="text-xl font-bold text-white mb-6 pl-3 border-l-4 border-emerald-500 flex items-center gap-2">
                <i class="fa-solid fa-cannabis text-emerald-400"></i> Dispensary Plans (ร้านยา/กัญชา)
            </h3>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                @for(plan of dispensaryPlans(); track plan.id) {
                    <div class="bg-slate-900 border border-slate-800 rounded-xl p-6 hover:border-emerald-500/50 transition-all group relative">
                        <div class="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button (click)="editPlan(plan)" class="text-emerald-400 hover:text-white bg-slate-800 p-2 rounded-lg transition-colors"><i class="fa-solid fa-pen-to-square"></i></button>
                        </div>
                        <h3 class="text-xl font-bold text-white mb-1">{{ plan.name }}</h3>
                        <p class="text-slate-400 text-sm font-mono mb-4">{{ plan.id }}</p>
                        <p class="text-3xl font-black text-emerald-400 mb-6">฿{{ plan.price_monthly | number }} <span class="text-sm font-normal text-slate-500">/{{ plan.interval || 'month' }}</span></p>
                        <div class="space-y-2 text-sm text-slate-300">
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>Case Limit</span><span class="font-bold text-white">{{ plan.limits['medical_cases'] || 'Unlimited' }}</span></div>
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>User Limit</span><span class="font-bold text-white">{{ plan.limits['users'] || 'Unlimited' }}</span></div>
                            <div class="flex justify-between border-b border-slate-800 pb-2"><span>Overage Cost</span><span class="font-bold text-white">{{ plan.limits['overage_cost'] || 0 }} THB</span></div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}

<!-- Plan Edit Modal -->
@if(isPlanModalOpen() && editingPlan(); as plan) {
    <div class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm p-4" (click)="closePlanModal()">
         <div class="bg-slate-900 rounded-xl shadow-2xl w-full max-w-2xl border border-slate-700 overflow-hidden flex flex-col max-h-[90vh]" (click)="$event.stopPropagation()">
             <div class="p-6 border-b border-slate-800 flex justify-between items-center bg-slate-950">
                 <h2 class="text-xl font-bold text-white">Edit Plan: {{ plan.name }}</h2>
                 <button (click)="closePlanModal()" class="text-slate-500 hover:text-white"><i class="fa-solid fa-times text-xl"></i></button>
             </div>
             
             <div class="p-6 overflow-y-auto space-y-6">
                 <div>
                     <label class="text-xs text-slate-400 block mb-1 font-bold uppercase">Monthly Price (THB)</label>
                     <input type="number" [(ngModel)]="plan.price_monthly" class="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white font-bold text-lg focus:ring-2 focus:ring-purple-500 outline-none">
                 </div>
                 
                 <div class="grid grid-cols-2 gap-4">
                     <div>
                         <label class="text-xs text-slate-400 block mb-1 font-bold uppercase">Case Limit (Empty = Unlimited)</label>
                         <input type="number" [ngModel]="plan.limits['medical_cases']" (ngModelChange)="updatePlanLimit('medical_cases', $event)" class="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white focus:ring-2 focus:ring-purple-500 outline-none">
                     </div>
                     <div>
                         <label class="text-xs text-slate-400 block mb-1 font-bold uppercase">User Limit (Empty = Unlimited)</label>
                         <input type="number" [ngModel]="plan.limits['users']" (ngModelChange)="updatePlanLimit('users', $event)" class="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white focus:ring-2 focus:ring-purple-500 outline-none">
                     </div>
                     <div>
                         <label class="text-xs text-slate-400 block mb-1 font-bold uppercase">Overage Cost (THB)</label>
                         <input type="number" [ngModel]="plan.limits['overage_cost']" (ngModelChange)="updatePlanLimit('overage_cost', $event)" class="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white focus:ring-2 focus:ring-purple-500 outline-none">
                     </div>
                     <div>
                         <label class="text-xs text-slate-400 block mb-1 font-bold uppercase">Partner Connections</label>
                         <input type="number" [ngModel]="plan.limits['partner_connections']" (ngModelChange)="updatePlanLimit('partner_connections', $event)" class="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white focus:ring-2 focus:ring-purple-500 outline-none">
                     </div>
                 </div>
                 
                 <div>
                     <h3 class="text-sm font-bold text-slate-300 mb-3 border-b border-slate-800 pb-1 uppercase tracking-wider">Features</h3>
                     <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                         @for(feature of featureList; track feature.key) {
                             <label class="flex items-center gap-3 p-3 rounded bg-slate-800 border border-slate-700 cursor-pointer hover:border-purple-500 transition-colors">
                                 <input type="checkbox" [checked]="plan.features[feature.key]" (change)="togglePlanFeature(feature.key, $event)" class="w-4 h-4 rounded text-purple-600 focus:ring-purple-500 bg-slate-900 border-slate-600">
                                 <span class="text-sm text-slate-200">{{ feature.label }}</span>
                             </label>
                         }
                     </div>
                 </div>
             </div>

             <div class="p-6 border-t border-slate-800 bg-slate-950 flex justify-end gap-3">
                 <button (click)="closePlanModal()" class="px-4 py-2 bg-slate-800 text-slate-300 rounded hover:bg-slate-700 font-bold transition-colors">Cancel</button>
                 <button (click)="savePlan()" [disabled]="isProcessingAction()" class="px-6 py-2 bg-purple-600 text-white rounded font-bold hover:bg-purple-500 disabled:opacity-50 transition-colors flex items-center gap-2">
                    @if(isProcessingAction()) { <i class="fa-solid fa-spinner animate-spin"></i> }
                    {{ isProcessingAction() ? 'Saving...' : 'Save Changes' }}
                 </button>
             </div>
         </div>
    </div>
}
